import Footnotes from './Footnotes';

export default Footnotes;
